if (!customElements.get('tss-homepage-social')) {
  customElements.define('tss-homepage-social', class extends HTMLElement {
    connectedCallback() {
      this.reviewTrack = this.querySelector('[data-review-track]');
      this.querySelector('[data-review-prev]')?.addEventListener('click', () => this.moveReviews(-1));
      this.querySelector('[data-review-next]')?.addEventListener('click', () => this.moveReviews(1));
      this.startHeroGalleries();
      this.loadCustomerPhotos();
    }

    moveReviews(direction) {
      if (!this.reviewTrack) return;
      const card = this.reviewTrack.querySelector('.tss-home__review');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.reviewTrack).columnGap) || 0;
      const visibleCards = matchMedia('(max-width: 600px)').matches ? 1 : (matchMedia('(max-width: 990px)').matches ? 2 : 4);
      this.reviewTrack.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap) * visibleCards, behavior: 'smooth' });
    }

    startHeroGalleries() {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.querySelectorAll('[data-fade-gallery]').forEach((gallery, galleryIndex) => {
        const slides = [...gallery.querySelectorAll('.tss-home__hero-slide')];
        if (slides.length < 2) return;
        let activeIndex = 0;
        const advance = () => {
          slides[activeIndex].classList.remove('is-active');
          activeIndex = (activeIndex + 1) % slides.length;
          slides[activeIndex].classList.add('is-active');
        };
        window.setTimeout(() => {
          advance();
          window.setInterval(advance, 9000);
        }, 3000 + (galleryIndex * 3000));
      });
    }

    async loadCustomerPhotos() {
      const service = String(this.dataset.galleryUrl || '').replace(/\/$/, '');
      const section = this.querySelector('[data-home-stories]');
      const grid = this.querySelector('[data-home-story-grid]');
      if (!service || !section || !grid) return;
      try {
        const response = await fetch(`${service}/api/gallery`);
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Unable to load customer photos');
        const photos = (data.photos || []).slice(0, 6);
        if (!photos.length) return;
        photos.forEach(photo => grid.append(this.createPhoto(photo)));
        section.hidden = false;
      } catch (_) {
        section.hidden = true;
      }
    }

    createPhoto(photo) {
      const link = document.createElement('a');
      link.className = 'tss-home__story';
      link.href = photo.productUrl || '/pages/customer-photos';
      const image = document.createElement('img');
      image.src = photo.photoUrl;
      image.alt = `${photo.name || 'Customer'}’s sign on display`;
      image.loading = 'lazy';
      image.decoding = 'async';
      link.append(image);
      const captionText = this.formatCustomerName(photo.name);
      if (captionText) {
        const caption = document.createElement('span');
        caption.textContent = captionText;
        link.append(caption);
      }
      return link;
    }

    formatCustomerName(name) {
      const parts = String(name || '').trim().replace(/\s+/g, ' ').split(' ').filter(Boolean);
      if (!parts.length) return '';
      if (parts.length === 1) return parts[0];
      const lastInitial = parts.at(-1).replace(/[^a-z]/gi, '').charAt(0).toUpperCase();
      return lastInitial ? `${parts[0]} ${lastInitial}.` : parts[0];
    }
  });
}
